module.exports = require("osnova-module-socket.io");


//////////////////
// WEBPACK FOOTER
// external "osnova-module-socket.io"
// module id = 24
// module chunks = 0